(function () {
  'use strict';

  function initHeader() {
    var header = document.querySelector('[data-trebo-header]');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initReveal() {
    var items = document.querySelectorAll('.reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
  }

  function initTicker() {
    document.querySelectorAll('[data-ticker-track]').forEach(function (track) {
      if (track.parentNode.children.length > 1) return;
      var clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.parentNode.appendChild(clone);
    });
  }

  function initForm() {
    var root = document.querySelector('[data-trebo-form]');
    if (!root) return;
    var form = root.querySelector('form');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
    var bar = root.querySelector('[data-progress-bar]');
    var counter = root.querySelector('[data-step-counter]');
    var backBtn = root.querySelector('[data-back]');
    var current = 0;

    function show(i) {
      current = i;
      steps.forEach(function (s, idx) {
        var active = idx === i;
        s.hidden = !active;
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      if (bar) bar.style.width = (((i + 1) / steps.length) * 100) + '%';
      if (counter) counter.textContent = (i + 1) + ' / ' + steps.length;
      if (backBtn) backBtn.hidden = i === 0;
      var focusable = steps[i].querySelector('input:not([type=hidden]):not([type=radio]), [data-choice]');
      if (focusable && window.matchMedia('(min-width: 768px)').matches) {
        setTimeout(function () { focusable.focus(); }, 60);
      }
    }

    function setError(step, msg) {
      var err = step.querySelector('[data-error]');
      if (err) err.textContent = msg || '';
      step.querySelectorAll('.input').forEach(function (inp) {
        inp.classList.toggle('is-invalid', !!msg && !inp.value.trim());
      });
    }

    function validate(step) {
      var required = Array.prototype.slice.call(step.querySelectorAll('[data-required]'));
      for (var k = 0; k < required.length; k++) {
        var inp = required[k];
        if (inp.type === 'radio') {
          var name = inp.name;
          var checked = step.querySelector('input[name="' + name + '"]:checked');
          if (!checked) return step.getAttribute('data-msg-required') || 'Elige una opción para continuar.';
          continue;
        }
        var val = inp.value.trim();
        if (!val) return step.getAttribute('data-msg-required') || 'Este campo es obligatorio.';
        if (inp.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) return step.getAttribute('data-msg-email') || 'Introduce un email válido.';
        if (inp.type === 'tel' && val.replace(/\D/g, '').length < 7) return step.getAttribute('data-msg-phone') || 'Introduce un teléfono válido.';
      }
      return '';
    }

    function next() {
      var step = steps[current];
      var msg = validate(step);
      if (msg) { setError(step, msg); return; }
      setError(step, '');
      if (current < steps.length - 1) show(current + 1);
    }

    root.querySelectorAll('[data-next]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); next(); });
    });

    if (backBtn) backBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (current > 0) show(current - 1);
    });

    root.querySelectorAll('[data-skip]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var target = root.querySelector(btn.getAttribute('data-skip'));
        if (target) target.value = btn.getAttribute('data-skip-value') || '';
        setError(steps[current], '');
        if (current < steps.length - 1) show(current + 1);
      });
    });

    root.querySelectorAll('[data-choice]').forEach(function (label) {
      var input = label.querySelector('input[type=radio]');
      if (!input) return;
      input.addEventListener('change', function () {
        root.querySelectorAll('[data-choice]').forEach(function (l) { l.classList.remove('is-selected'); });
        label.classList.add('is-selected');
        setTimeout(next, 220);
      });
    });

    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.tagName === 'INPUT' && e.target.type !== 'radio') {
        if (current < steps.length - 1) { e.preventDefault(); next(); }
      }
    });

    form.addEventListener('submit', function (e) {
      var step = steps[current];
      var msg = validate(step);
      if (msg) { e.preventDefault(); setError(step, msg); return; }
      var submit = form.querySelector('[type=submit]');
      if (submit) { submit.disabled = true; submit.classList.add('is-loading'); }
    });

    show(0);
  }

  function init() {
    initHeader();
    initReveal();
    initTicker();
    initForm();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function () {
    initHeader();
    initReveal();
    initTicker();
    initForm();
  });
})();
